import { create } from "zustand";
import { createStore } from "zustand/vanilla";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { produce } from "immer";
import axios from "axios";
import sanitizeHtml from "sanitize-html";
import socket from "./socket";

import api from "./api";
// eslint-disable-next-line import/no-cycle
import notify from "./Main/Notifications/Notifications";

axios.defaults.headers.common["Cache-Control"] = "no-cache, no-transform";
// axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         console.error(`axios error: "${error.code}" on url: "${error.config.url}"`, error);
//         return { data: {} };
//     },
// );

let socketInitTimeStamp;
let datasetsSendToAllCount;

const getTask = async (id) => {
    // TODO: test without task, needs to be somehow dynamic, if tasks is not installed
    const { data } = await axios.post("/api/plugin/tasks/tasks/find", { id });
    return data.is_closed === 1;
};
// Log every time state is changed
// const log = (config) => (set, get, storeApi) => config((args) => {
//     console.log("  applying", args);
//     set(args);
//     console.log("  new state", get());
// }, get, storeApi);

const manageAuth = (baseUrl, authToken) => {
    const {
        app: {
            isAuthenticated,
            setIsAuthenticated,
            setUserInfo,
            // fetchRights,
            // fetchMasterData,
            clearRights,
            // fetchAddressConfig,
            // fetchAddIns,
            // fetchPluginsSettings,
            // getElectronConfig,
        },
        // dashboard: { fetchWidgets, clearWidgets },
        // layouts: { fetch: fetchLayouts },
        dashboard: {
            // fetch: fetchDashboard,
            clear: clearDashboard,
        },
        menu: {
            // fetch: fetchMenu,
            clear: clearMenu,
        },
        // eslint-disable-next-line no-use-before-define
    } = store.getState();

    if (baseUrl && authToken) {
        if (!isAuthenticated) {
            setTimeout(() => {
                setIsAuthenticated(true);
                // fetchWidgets();
                // fetchDashboard();
                // fetchMenu();
                // fetchRights();
                // fetchLayouts();
                // fetchAddressConfig();
                // fetchAddIns();
                // fetchPluginsSettings();
                // fetchMasterData();
                //
                // // eslint-disable-next-line no-undef
                // if (!_isBrowser) {
                //     getElectronConfig();
                // }
            }, 0);
        }
    } else if (isAuthenticated) {
        setTimeout(() => {
            setIsAuthenticated(false);
            setUserInfo({});
            // clearWidgets();
            clearDashboard();
            clearMenu();
            clearRights();
        }, 0);
    }
};
const validateWidgets = (widgets, availableWidgets) => {
    const tmpWidgets = [];
    widgets.forEach((widget) => {
        const tmpWidget = {
            ...widget,
        };

        const availableWidget = availableWidgets.find(
            (item) => item.component === widget.component && item.pluginId === widget.pluginId,
        );

        if (availableWidget) {
            tmpWidget.hasSettings = availableWidget.hasSettings;
            tmpWidget.plugin = availableWidget.plugin;
            tmpWidget.title = availableWidget.title;
            tmpWidget.icon = availableWidget.icon;
            tmpWidget.isCore = availableWidget.isCore;

            if (availableWidget.accessDenied) {
                tmpWidget.isCore = true;
                tmpWidget.component = "AccessDenied";
            }

            if (availableWidget.positions) {
                if (availableWidget.positions.minW) {
                    tmpWidget.positions.minW = availableWidget.positions.minW;
                }

                if (availableWidget.positions.minH) {
                    tmpWidget.positions.minH = availableWidget.positions.minH;
                }
            }
        } else {
            tmpWidget.isCore = true;
            tmpWidget.component = "NotFound";
        }

        if (tmpWidget.positions.y === null) {
            tmpWidget.positions.y = Infinity;
        }

        tmpWidgets.push(tmpWidget);
    });

    return tmpWidgets;
};

const store = createStore(subscribeWithSelector(immer((set, get) => ({
    app: {
        baseUrl: "",
        authToken: "",
        refreshToken: "",
        socketId: null,
        isInactive: false,
        isAuthenticated: false,
        darkMode: false,
        zoom: 1,
        currentRoute: { route: "/" },
        appInfo: {},
        userInfo: {},
        rights: {},
        addressConfig: [],
        boilerplates: [
        ],
        addIns: [],
        pluginSettings: {},
        sleep: false,
        systemIdleTime: null,
        electronConfig: null,
        setBaseUrl: (baseUrl) => set((state) => {
            state.app.baseUrl = baseUrl;
            axios.defaults.baseURL = baseUrl;

            manageAuth(baseUrl, get().app.authToken);
        }),
        getElectronConfig: async () => {
            try {
                // eslint-disable-next-line no-undef
                const config = await getElectronConfig();
                set((state) => {
                    state.app.electronConfig = config;
                });
            } catch (e) {
                console.error(e);
            }
        },
        updateElectronConfig: (arg) => set((state) => {
            state.app.electronConfig = arg;
        }),
        wakeUp: () => set((state) => {
            state.app.sleep = false;
            state.app.isInactive = false;
            // eslint-disable-next-line no-undef
            wakeUp();

            // TODO: dirty fix for PTMInput type="editor" to reset initial value on return from sleep mode, to keep the changed content
            window.dispatchEvent(new CustomEvent("wakeUp"));
        }),
        sendToSleep: (val) => set((state) => {
            if (!(state.app.electronConfig?.profiles && state.app.electronConfig.profiles[state.app.electronConfig.selectedProfile] && state.app.electronConfig.profiles[state.app.electronConfig.selectedProfile].disableSleepTimer)) {
                state.app.sleep = val;
            }
        }),
        setSystemIdleTime: (val) => set((state) => {
            if (!(state.app.electronConfig?.profiles && state.app.electronConfig.profiles[state.app.electronConfig.selectedProfile] && state.app.electronConfig.profiles[state.app.electronConfig.selectedProfile].disableSleepTimer)) {
                state.app.systemIdleTime = val;
            }
        }),
        setInactive: () => set((state) => {
            state.app.isInactive = true;
        }),
        setAuthToken: (authToken, updateStore) => set((state) => {
            state.app.authToken = authToken;
            axios.defaults.headers.common.Authorization = authToken;

            manageAuth(get().app.baseUrl, authToken);

            if (updateStore) {
                let configStore;

                // eslint-disable-next-line no-undef
                if (!_isBrowser) {
                    const Store = window.require("electron-store");
                    configStore = new Store();
                }

                if (get().app.appInfo.is_helpdesk) {
                    window.localStorage.setItem("ptmToken", authToken);
                    // eslint-disable-next-line no-undef
                } else if (_isBrowser) {
                    window.localStorage.setItem("ptmToken", authToken);
                } else {
                    configStore.set("ptmToken", authToken);
                }
            }
        }),
        setRefreshToken: (refreshToken, updateStore) => set((state) => {
            state.app.refreshToken = refreshToken;

            if (updateStore) {
                let configStore;

                // eslint-disable-next-line no-undef
                if (!_isBrowser) {
                    const Store = window.require("electron-store");
                    configStore = new Store();
                }

                if (get().app.appInfo.is_helpdesk) {
                    window.localStorage.setItem("ptmRefreshToken", refreshToken);
                    // eslint-disable-next-line no-undef
                } else if (_isBrowser) {
                    window.localStorage.setItem("ptmRefreshToken", refreshToken);
                } else {
                    configStore.set("ptmRefreshToken", refreshToken);
                }
            }
        }),
        setSocketId: (socketId) => set((state) => {
            state.app.socketId = socketId;
        }),
        setIsAuthenticated: (isAuthenticated) => set((state) => {
            state.app.isAuthenticated = isAuthenticated;
        }),
        setDarkMode: (darkMode, update = true) => set((state) => {
            state.app.darkMode = darkMode;

            window.dispatchEvent(new CustomEvent("reactToAngular", {
                detail: {
                    action: "changeTheme",
                    value: {
                        theme: darkMode ? "dunkel" : "hell",
                    },
                },
            }));

            if (update) {
                if (get().app.appInfo.is_helpdesk) {
                    window.localStorage.setItem("theme", darkMode ? "slate" : "simplex");
                } else {
                    (async () => {
                        await api.dashboard.setTheme({
                            id: get().dashboard.id,
                            theme: darkMode ? "slate" : "simplex",
                        });
                    })();
                }
            }
        }),
        openSLDialog: () => {
            get().dashboard.openDialog({
                icon: "upload",
                title: "SL Import",
                plugin: "SlExtensions",
                component: "SyncGusToSL",
                data: { slNumber: 100917, slType: "customer", nipNumber: 5711480528 },
            });
        },
        setZoom: (zoom) => {
            // eslint-disable-next-line no-undef
            updateElectronConfig(zoom, true);
            set((state) => {
                state.app.zoom = zoom;
            });
        },
        // setInitialDarkMode: (darkMode) => set((state) => {
        //     state.app.darkMode = darkMode;
        // }),

        setCurrentRoute: (currentRoute) => set((state) => {
            state.app.currentRoute = currentRoute;
        }),

        setAppInfo: (appInfo) => set((state) => {
            state.app.appInfo = appInfo;
        }),
        setUserInfo: (userInfo) => set((state) => {
            state.app.userInfo = userInfo;
        }),
        fetchRights: () => {
            if (!get().app.appInfo.is_helpdesk) {
                (async () => {
                    try {
                        const { data: rights } = await api.rights.read();

                        set((state) => {
                            state.app.rights = rights;
                        });
                    } catch (e) {
                        if (e?.response?.status === 401) {
                            get().app.logout();
                        }
                    }
                })();
            }
        },

        fetchBoilerplates: async () => {
            if (!get().app.appInfo.is_helpdesk) {
                const { data: boilerplates } = await api.boilerplates.read("actives");
                set((state) => {
                    state.app.boilerplates = boilerplates;
                });
            }
        },

        fetchMasterData: async () => {
            await get().app.fetchBoilerplates();
        },

        clearRights: () => {
            set((state) => {
                state.app.rights = [];
            });
        },
        fetchAddressConfig: async () => {
            if (!get().app.appInfo.is_helpdesk) {
                const { data } = await api.settings.get({
                    myself: true, module: "contacts", name: "google_address_config",
                });
                set((state) => {
                    state.app.addressConfig = data;
                });
            }
        },
        fetchAddIns: async () => {
            const { data: addIns } = await api.addIns.get();
            set((state) => {
                state.app.addIns = addIns;
            });
        },
        findAddIns: (category) => (get().app.addIns.length !== 0 && get().app.addIns[category] ? get().app.addIns[category] : []),
        fetchPluginsSettings: async () => {
            const { data: pluginSettings } = await api.plugins.getSettings();
            set((state) => {
                state.app.pluginSettings = pluginSettings;
            });

            await Promise.all(Object.keys(pluginSettings).map(async (plugin) => {
                // if a plugin has the user_store property, load the corresponding store module
                if (pluginSettings[plugin] && pluginSettings[plugin].use_store) {
                    // const path = `./Plugins/${plugin[0].toUpperCase()}${plugin.slice(1)}/store`;
                    // eslint-disable-line
                    await import("./Plugins/"+plugin[0].toUpperCase()+plugin.slice(1)+"/store").then((module) => {// eslint-disable-line
                        // initialize the master data
                        if (pluginSettings[plugin].store_functions) {
                            pluginSettings[plugin].store_functions.forEach((func) => {
                                module.default.getState()?.[func]();
                            });
                        } else {
                            module.default.getState()?.fetchMasterData();
                            module.default.getState()?.fetchTaskData();
                        }
                    }).catch(() => console.error("store.fetchPluginsSettings: store missing for", plugin));
                }
                await import("./Plugins/"+plugin[0].toUpperCase()+plugin.slice(1)+"/AddIns/addInStore").then((module) => {// eslint-disable-line
                    module.default.getState().init();
                }).catch(() => console.error("store.fetchPluginsSettings: addInStore missing for", plugin));
            }));
        },
        checkChangeLogs: async (userId) => {
            const { data } = await api.users.getLatestChangeLogs(userId);
            if (data.length > 0) {
                const { openDialog } = get().dashboard;
                openDialog({
                    icon: "info",
                    title: "Updates",
                    component: "NewChangeLogs",
                    data,
                });
            }
        },
        logout: () => {
            let configStore;
            let ipcRenderer;

            // eslint-disable-next-line no-undef
            if (!_isBrowser) {
                const Store = window.require("electron-store");
                configStore = new Store();
                ipcRenderer = window.require("electron").ipcRenderer;
            }

            if (get().app.appInfo.is_helpdesk) {
                window.localStorage.removeItem("ptmToken");
                window.localStorage.removeItem("ptmRefreshToken");
                // eslint-disable-next-line no-undef
            } else if (_isBrowser) {
                window.localStorage.removeItem("ptmToken");
                window.localStorage.removeItem("ptmRefreshToken");
            } else {
                if (configStore.has("ptmToken")) {
                    configStore.delete("ptmToken");
                }

                if (configStore.has("ptmRefreshToken")) {
                    configStore.delete("ptmRefreshToken");
                }
            }

            get().app.setAuthToken("");
            get().app.setRefreshToken("");

            // eslint-disable-next-line no-undef
            if (_isBrowser) {
                window.location.replace("/login");
            } else {
                ipcRenderer?.send("auth.logout");
            }
        },
    },
    layouts: {
        layouts: [],
        fetch: async () => {
            if (!get().app.appInfo.is_helpdesk) {
                const { data: layouts } = await api.gridLayouts.find();
                set((state) => {
                    state.layouts.layouts = layouts;
                });
            }
        },
        findLayout: (module, layoutId) => get().layouts.layouts.find((layout) => layout.module === module && layout.layout_id === layoutId),
        createLayout: async (module, layoutId, layout) => {
            const { data } = await api.gridLayouts.createLayout({ module, layout_id: layoutId, layout });
            set((state) => {
                state.layouts.layouts.push(data.insertId ? {
                    id: data.insertId,
                    module,
                    layout_id: layoutId,
                    layout,
                } : data);
            });
            return data.insertId ? {
                id: data.insertId,
                module,
                layout_id: layoutId,
                layout,
            } : data;
        },
        updateLayout: async (id, layout) => {
            await api.gridLayouts.updateLayout({ id, layout });
            set((state) => {
                state.layouts.layouts = produce(state.layouts.layouts, (draft) => {
                    draft[draft.findIndex((entry) => entry.id === id)].layout = layout;
                });
            });
        },
    },
    dashboard: {
        id: null,
        dashboardSelectionOpen: false,
        setDashboardSelectionOpen: (open) => {
            set((state) => {
                state.dashboard.dashboardSelectionOpen = open;
            });
        },
        dialogs: {
            currentOpenDialog: "",
            setCurrentOpenDialog: (dialogName) => {
                set((state) => {
                    state.dashboard.dialogs.currentOpenDialog = dialogName;
                });
            },
        },
        availableWidgets: [],
        widgets: {
            addWidgetDialogOpen: false,
            setAddWidgetDialogOpen: (open) => {
                set((state) => {
                    state.dashboard.widgets.addWidgetDialogOpen = open;
                });
            },
            left: [],
            main: [],
            right: [],
            widgetSearchHistory: [

            ],
            add: async (section, widget) => {
                const newWidget = {
                    id: null,
                    component: widget.component,
                    title: widget.title,
                    icon: widget.icon,
                    dynamicTitle: "",
                    dynamicIcon: "",
                    titleAddon: "",
                    clickableTitle: false,
                    titleTooltip: "",
                    onTitleClick: null,
                    reloadHandler: null,
                    isCore: widget.isCore,
                    plugin: !widget.isCore ? widget.plugin : null,
                    dashboardId: get().dashboard.id,
                    pluginId: !widget.isCore ? widget.pluginId : null,
                    section,
                    positions: {
                        x: 0, y: Infinity, w: 3, h: 3,
                    },
                    settings: {},
                    hasSettings: widget.hasSettings,
                };

                if (widget.positions) {
                    if (widget.positions.w) {
                        newWidget.positions.w = widget.positions.w;

                        if (section !== "main" && newWidget.positions.w > 5) {
                            newWidget.positions.w = 5;
                        }
                    }
                    if (widget.positions.h) {
                        newWidget.positions.h = widget.positions.h;
                    }
                    if (widget.positions.minW) {
                        newWidget.positions.minW = widget.positions.minW;
                    }
                    if (widget.positions.minH) {
                        newWidget.positions.minH = widget.positions.minH;
                    }
                }

                const { data: { id: newWidgetId } } = await api.widgets.add(newWidget);

                newWidget.id = newWidgetId;

                set((state) => {
                    state.dashboard.widgets[section].push(newWidget);
                });

                if (section !== "main") {
                    if (!get().dashboard.sidebars[section].enabled) {
                        window.dispatchEvent(new CustomEvent("reactToAngular", {
                            detail: {
                                action: "toggleSidebar",
                                side: section,
                            },
                        }));
                    }
                }
            },
            updatePosition: async (section, item) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === parseInt(item.i),
                );
                const widget = get().dashboard.widgets[section][widgetIndex];

                if (widget && (item.x !== widget.positions.x
                    || item.y !== widget.positions.y
                    || item.w !== widget.positions.w
                    || item.h !== widget.positions.h)) {
                    const widgetNewPositions = {
                        x: item.x,
                        y: item.y,
                        w: item.w,
                        h: item.h === 1 ? widget.positions.h : item.h,
                    };

                    set((state) => {
                        const selectedWidget = state.dashboard.widgets[section][widgetIndex];

                        selectedWidget.positions = widgetNewPositions;
                    });

                    await api.widgets.updatePositions({
                        id: widget.id,
                        positions: widgetNewPositions,
                    });
                }
            },
            updatePositions: async (section, items) => {
                const toUpdate = [];
                items.forEach((item) => {
                    const widgetIndex = get().dashboard.widgets[section].findIndex(
                        (widget) => widget.id === parseInt(item.i),
                    );

                    const widget = get().dashboard.widgets[section][widgetIndex];

                    if (
                        widget && (
                            item.x !== widget.positions.x
                            || item.y !== widget.positions.y
                            || item.w !== widget.positions.w
                            || item.h !== widget.positions.h
                        )
                    ) {
                        toUpdate.push({
                            id: widget.id,
                            index: widgetIndex,
                            positions: {
                                x: item.x,
                                y: item.y,
                                w: item.w,
                                h: item.h === 1 ? widget.positions.h : item.h,
                            },
                        });
                    }
                });

                set((state) => {
                    for (let i = 0; i < toUpdate.length; i++) {
                        state.dashboard.widgets[section][toUpdate[i].index].positions = toUpdate[i].positions;
                    }
                });

                await Promise.all(toUpdate.map(async (item) => {
                    await api.widgets.updatePositions({
                        id: item.id,
                        positions: item.positions,
                    });
                }));
            },
            updateSettings: async (section, id, settings) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    const selectedWidget = state.dashboard.widgets[section][widgetIndex];

                    selectedWidget.dynamicTitle = settings.dynamicTitle || "";
                    selectedWidget.dynamicIcon = settings.dynamicIcon || "";
                    selectedWidget.settings = settings.settings || {};
                });

                await api.widgets.updateSettings({ id, ...settings });
            },
            setTitleAddon: async (section, id, titleAddon) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    state.dashboard.widgets[section][widgetIndex].titleAddon = titleAddon;
                });
            },
            setReloadHandler: async (section, id, reloadHandler) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    state.dashboard.widgets[section][widgetIndex].reloadHandler = reloadHandler;
                });
            },
            setTitleClick: async (section, id, clickableTitle, onTitleClick, titleTooltip) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    state.dashboard.widgets[section][widgetIndex].clickableTitle = clickableTitle;
                    state.dashboard.widgets[section][widgetIndex].onTitleClick = onTitleClick;
                    state.dashboard.widgets[section][widgetIndex].titleTooltip = titleTooltip;
                });
            },
            show: async (section, id) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    if (widgetIndex !== -1) {
                        state.dashboard.widgets[section][widgetIndex].isHidden = false;
                    }
                });

                await api.widgets.show(id);
            },
            hide: async (section, id) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    if (widgetIndex !== -1) {
                        state.dashboard.widgets[section][widgetIndex].isHidden = true;
                    }
                });

                await api.widgets.hide(id);
            },
            remove: async (section, id) => {
                const widgetIndex = get().dashboard.widgets[section].findIndex(
                    (widget) => widget.id === id,
                );

                set((state) => {
                    if (widgetIndex !== -1) {
                        state.dashboard.widgets[section].splice(widgetIndex, 1);
                    }
                });

                await api.widgets.remove(id);
            },
            updateSearchHistory: (widgetId, searchString) => {
                const searchHistory = get().dashboard.widgets.widgetSearchHistory;

                const widget = searchHistory.find((history) => history.widgetId === widgetId);
                if (widget && !widget.history.includes(searchString)) {
                    set((state) => {
                        state.dashboard.widgets.widgetSearchHistory = produce(state.dashboard.widgets.widgetSearchHistory, (draft) => {
                            const index = draft.findIndex((e) => e.widgetId === widgetId);
                            if (draft[index].history.length === 5) {
                                draft[index].history.shift();
                            }
                            draft[index].history.push(searchString);
                        });
                    });
                } else {
                    const newEntry = {};
                    newEntry.widgetId = widgetId;
                    newEntry.history = [];
                    newEntry.history.push(searchString);

                    set((state) => {
                        state.dashboard.widgets.widgetSearchHistory = produce(state.dashboard.widgets.widgetSearchHistory, (draft) => {
                            draft.push(newEntry);
                        });
                    });
                }
            },
            deleteSearchHistoryEntry: (searchString, widgetId) => {
                set((state) => {
                    state.dashboard.widgets.widgetSearchHistory = produce(state.dashboard.widgets.widgetSearchHistory, (draft) => {
                        const index = draft.findIndex((e) => e.widgetId === widgetId);

                        const stringIndex = draft[index].history.findIndex((entry) => entry === searchString);

                        draft[index].history.splice(stringIndex, 1);
                    });
                });
            },
        },
        sidebars: {
            left: {
                enabled: false,
                width: null,
            },
            right: {
                enabled: false,
                width: null,
            },
            setEnabled: (side, value) => {
                if (get().dashboard.id && value !== get().dashboard.sidebars[side].enabled) {
                    set((state) => {
                        if (!get().dashboard.sidebars[side].width) {
                            state.dashboard.sidebars[side].width = 150;
                        }
                        state.dashboard.sidebars[side].enabled = value;
                    });

                    (async () => {
                        await api.dashboard.updateSidebarEnabled({
                            id: get().dashboard.id,
                            side,
                            enabled: value,
                        });
                    })();
                }
            },
            setWidth: (side, value) => {
                if (get().dashboard.id && value !== get().dashboard.sidebars[side].width) {
                    set((state) => {
                        state.dashboard.sidebars[side].width = value;
                    });

                    (async () => {
                        await api.dashboard.updateSidebarWidth({
                            id: get().dashboard.id,
                            side,
                            width: value,
                        });
                    })();
                }
            },
        },
        incEmail: null,
        incEmailTabs: [],
        setIncEmail: (data) => {
            set((state) => {
                state.dashboard.incEmail = data;
            });
        },
        addEmailTab: (id) => {
            set((state) => {
                state.dashboard.incEmailTabs.push(id);
            });
        },
        closeEmailTabs: (id) => {
            const tabs = get().dashboard.incEmailTabs;
            const close = get().dashboard.closeTab;
            if (id) {
                tabs.filter((tab) => tab !== id).forEach((tab) => {
                    close(tab);
                });
            } else {
                tabs.forEach((tab) => {
                    close(tab);
                });
            }
            set((state) => {
                state.dashboard.incEmailTabs = [];
                state.dashboard.incEmail = null;
            });
        },
        currentTab: 0,
        lastTabId: 0,
        tabs: [],
        dialog: null,
        dialogCache: [],
        confirmDiscardAll: false,
        sender: null,
        setSender: (sender) => {
            set((state) => {
                state.dashboard.sender = sender;
            });
        },
        setConfirmDiscardAll: (val) => {
            set((state) => {
                state.dashboard.confirmDiscardAll = val;
            });
        },
        fetch: (id) => {
            (async () => {
                const { data: availableWidgets } = await api.widgets.read();
                const { data: dashboard } = id ? await api.dashboard.find(id) : await api.dashboard.findMyself();
                set((state) => {
                    state.dashboard.id = dashboard.id;
                    state.dashboard.availableWidgets = availableWidgets;
                    state.dashboard.zoom = get().app.electronConfig ? get().app.electronConfig.profiles[get().app.electronConfig.selectedProfile].zoom : 1;
                    // state.dashboard.widgets = validateWidgets(
                    //     layoutProfile.widgets, availableWidgets,
                    // );
                    state.dashboard.sidebars.left.enabled = dashboard.sidebars.left.enabled;
                    state.dashboard.sidebars.left.width = dashboard.sidebars.left.width;
                    state.dashboard.sidebars.right.enabled = dashboard.sidebars.right.enabled;
                    state.dashboard.sidebars.right.width = dashboard.sidebars.right.width;

                    state.dashboard.widgets.left = validateWidgets(dashboard.widgets.left, availableWidgets);
                    state.dashboard.widgets.main = validateWidgets(dashboard.widgets.main, availableWidgets);
                    state.dashboard.widgets.right = validateWidgets(dashboard.widgets.right, availableWidgets);
                });

                if (get().app.appInfo.is_helpdesk) {
                    get().app.setDarkMode((window.localStorage.getItem("theme") || "simplex") === "slate", false);
                } else {
                    get().app.setDarkMode(dashboard.theme === "slate", false);
                }
            })();
        },
        change: async (id) => {
            set((state) => {
                state.dashboard.fetch(id);
            });
        },
        clear: () => {
            set((state) => {
                state.dashboard.widgets.dashboard = [];
                state.dashboard.widgets.left = [];
                state.dashboard.widgets.right = [];
            });
        },
        closeAll: () => {
            set((state) => {
                state.app.currentRoute = { route: "/" };
                state.dashboard.tabs = [];
                state.dashboard.currentTab = 0;
            });
        },
        closeNonDirty: () => {
            set((state) => {
                state.app.currentRoute = { route: "/" };
                state.dashboard.tabs = state.dashboard.tabs.filter((tab) => tab.isDirty);
                state.dashboard.currentTab = 0;
            });
        },
        setCurrentTab: (id) => {
            set((state) => {
                state.dashboard.currentTab = id;
            });

            setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
            }, 25);
        },
        setTabIsDirty: (id, value) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);

                if (index !== -1) {
                    state.dashboard.tabs[index].isDirty = value;
                }
            });
        },
        setTabIsEditing: (id, value) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);

                if (index !== -1) {
                    if (value === "dialog" && state.dashboard.tabs[index].isEditing === "dialog") {
                        state.dashboard.tabs[index].isEditing = false;
                    } else {
                        state.dashboard.tabs[index].isEditing = value;
                    }
                }
            });
        },
        setPopover: (id, content) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);
                if (index !== -1) {
                    state.dashboard.tabs[index].popover = content;
                }
            });
        },
        handleEscapeClicked: (id) => {
            const index = get().dashboard.tabs.findIndex((tab) => tab.id === id);
            const { hooks } = get().dashboard.tabs[index];
            const close = get().dashboard.closeTab;
            if (index !== -1 && get().dashboard.tabs[index].isEditing && get().dashboard.tabs[index].isEditing !== "dialog") {
                set((state) => {
                    hooks[state.dashboard.tabs[index].isEditing]();
                    state.dashboard.tabs[index].isEditing = false;
                });
            } else {
                close(id);
            }
        },
        addHook: (id, hook) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);

                if (index !== -1) {
                    state.dashboard.tabs[index].hooks = { ...state.dashboard.tabs[index].hooks, ...hook };
                }
            });
        },
        changeTabTitle: (id, value) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);

                if (index !== -1) {
                    state.dashboard.tabs[index].title = value;
                }
            });
        },
        getTabTitle: (id) => {
            const index = get().dashboard.tabs.findIndex((tab) => tab.id === id);
            return get().dashboard.tabs[index].title;
        },
        getTabData: (id) => {
            const index = get().dashboard.tabs.findIndex((tab) => tab.id === id);
            return get().dashboard.tabs[index].data;
        },
        changeTabData: (id, value) => {
            set((state) => {
                const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);
                if (index !== -1) {
                    state.dashboard.tabs[index].data = value;
                }
            });
        },
        closeTab: (id) => {
            set((state) => {
                // const index = state.dashboard.tabs.findIndex((tab) => tab.id === id);
                // if (index >= 0) {
                //     state.dashboard.tabs.splice(index, 1);
                // }
                state.dashboard.tabs = state.dashboard.tabs.filter((tab) => tab.id !== id);
                if (state.dashboard.currentTab === id) {
                    if (state.dashboard.tabs.length === 0) {
                        state.dashboard.currentTab = 0;
                    } else {
                        state.dashboard.currentTab = state.dashboard.tabs[state.dashboard.tabs.length - 1].id;
                    }
                }
            });
        },
        addTab: (tab, newTab, refreshData) => {
            const index = get().dashboard.tabs.findIndex((getTab) => (
                tab.data && getTab.data
                    ? (tab.data.id === getTab.data.id)
                    && (tab.component === getTab.component)
                    && (!tab.data.preFill && !getTab.data.preFill ? true : tab.data.preFill?.contact_id === getTab.data.preFill?.contact_id)
                    && (!tab.data.incEmail && !getTab.data.incEmail ? true : tab.data.incEmail?.subject === getTab.data.incEmail?.subject)
                    : (tab.component === getTab.component)));
            set((state) => {
                if (index === -1 || newTab) {
                    state.dashboard.lastTabId++;
                    tab.id = state.dashboard.lastTabId;
                    tab.isDirty = false;
                    tab.isEditing = false;
                    tab.hooks = {};
                    state.dashboard.tabs.push(tab);
                    state.dashboard.currentTab = tab.id;
                } else if (refreshData) {
                    state.dashboard.currentTab = state.dashboard.tabs[index].id;
                    state.dashboard.tabs[index].data = tab.data;
                } else {
                    state.dashboard.currentTab = state.dashboard.tabs[index].id;
                }
            });
        },
        checkIsDirty: (tab) => get().dashboard.tabs.some((checkTab) => checkTab.id === tab && checkTab.isDirty),
        openDialog: (dialog) => {
            if (!get().dashboard.dialog) {
                set((state) => {
                    state.dashboard.dialog = dialog;
                });
            } else {
                set((state) => {
                    state.dashboard.dialogCache.push(dialog);
                });
            }
        },
        closeDialog: () => {
            if (get().dashboard.dialogCache.length > 0) {
                set((state) => {
                    // eslint-disable-next-line prefer-destructuring
                    state.dashboard.dialog = state.dashboard.dialogCache[0];
                    state.dashboard.dialogCache.splice(0, 1);
                });
            } else {
                set((state) => {
                    state.dashboard.dialog = null;
                });
            }
        },
        handleCloseAll: (e) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (get().dashboard.tabs.some((tab) => tab.isDirty)) {
                get().dashboard.closeNonDirty();
                get().dashboard.setConfirmDiscardAll(true);
                return true;
            }
            get().dashboard.closeAll();
            return false;
        },
    },
    notifications: {
        open: false,
        setOpen: (open) => {
            set((state) => {
                state.notifications.open = open;
            });
        },
    },
    menu: {
        isCollapsed: true,
        entries: {},
        width: 42.5,
        setWidth: (width) => {
            set((state) => {
                state.menu.width = width;
            });
        },
        toggleCollapsed: () => {
            set((state) => {
                state.menu.isCollapsed = !state.menu.isCollapsed;
            });
        },
        fetch: async () => {
            const { data: entries } = await api.menu.read();
            // eslint-disable-next-line no-undef
            if (!_isBrowser && get().app.electronConfig) {
                entries.bottom[0].children.push({
                    display: "Client Einstellungen",
                    icon: "user-cog",
                    tab: "ClientConfig",
                    isCore: true,
                });
            }
            set((state) => {
                state.menu.entries = entries;
                console.log(entries);
            });
        },
        addBadge: (category, plugin, tabComponent, badge) => {
            // TODO: recursive, currently only first level
            set((state) => {
                const index = state.menu.entries[category].findIndex((item) => item.module === plugin && item.tab === tabComponent);
                if (!state.menu.entries[category][index].badges) {
                    state.menu.entries[category][index].badges = [];
                }

                state.menu.entries[category][index].badges.push(badge);
            });
        },
        removeBadge: (category, plugin, tabComponent, badgeId) => {
            // TODO: recursive, currently only first level
            set((state) => {
                const index = state.menu.entries[category].findIndex((item) => item.module === plugin && item.tab === tabComponent);
                if (state.menu.entries[category][index].badges) {
                    const badgeIndex = state.menu.entries[category][index].badges.findIndex((item) => item.id === badgeId);

                    if (badgeIndex !== -1) {
                        state.menu.entries[category][index].badges.splice(badgeIndex, 1);
                    }
                }
            });
        },
        clear: () => {
            set((state) => {
                state.menu.entries = {};
            });
        },
    },
    socket: {
        isConnected: false,
        users: [],
        setIsConnected: (isConnected) => set((state) => {
            state.socket.isConnected = isConnected;
        }),
        setUsers: (users) => set((state) => {
            state.socket.users = users;
        }),
        updateUser: (user) => {
            set((state) => {
                const userIndex = state.socket.users.findIndex(
                    (innerUser) => innerUser.id === user.id,
                );

                if (userIndex !== -1) {
                    state.socket.users[userIndex] = user;
                } else {
                    state.socket.users.push(user);
                }
            });
        },
        removeUser: (id) => {
            set((state) => {
                const userIndex = state.socket.users.findIndex((user) => user.id === id);
                if (userIndex !== -1) state.socket.users.splice(userIndex, 1);
            });
        },
        logoutUser: (id) => {
            socket.emit("users.logoutUser", id);
        },
    },
    errors: {
        // TODO: Fehleranzeige
        // TODO: func: mark as read
        // TODO: func: mark all as read
        errors: [],
        addError: (code, message, details, obj) => {
            set((state) => {
                state.errors.errors.push({
                    code, message, details, obj, isUnread: true,
                });
            });
        },
    },
    contacts: {
        updateContacts: (contactId) => {
            socket.emit("contacts.contacts.update", contactId);
        },
    },

    datasets: {
        datasets: [],
        setDataSets: (datasets) => {
            // console.log("setDataSets", datasets);
            set((state) => {
                state.datasets.datasets = datasets;
            });
        },
        // fetchDatasets: () => {
        //     socket.emit("dataset.fetch");
        // },
        addDataset: (dataset) => {
            // set((state) => {
            //     console.log(state.app.userInfo);
            //     console.log(state.app.socketId);
            // });
            // console.log("dataset.add", dataset);
            socket.emitACK("dataset.add", dataset);
        },
        editDataset: (userId, tabId, mode) => {
            const dataset = get().datasets.datasets.find((dS) => dS.user_id === userId && dS.tab_id === tabId && dS.socket_id === get().app.socketId);
            if (dataset) {
                socket.emitACK("dataset.edit", { data: dataset, dataMode: mode });
            } else {
                socket.emitACK("dataset.edit", {
                    debug: {
                        userId, tabId, socketId: get().app.socketId, tabs: get().dashboard.tabs,
                    },
                    dataMode: mode,
                });
            }
        },
        removeDataset: (userId, tabId) => {
            const dataset = get().datasets.datasets.find((dS) => dS.user_id === userId && dS.tab_id === tabId && dS.socket_id === get().app.socketId);
            socket.emitACK("dataset.remove", dataset);
        },
    },
    custom: {
        setValue: (key, value) => {
            set((state) => {
                state.custom.values[key] = value;
            });
        },
        values: {},
    },
}))));

const useStore = create(store);

const handleAngularEvent = (e) => {
    const {
        app: {
            // setAuthToken,
            // setBaseUrl,
            // setInitialDarkMode,
            setCurrentRoute,
        },
        dashboard: {
            setCurrentTab, currentTab, addTab,
            // sidebars: { setEnabled: setSidebarEnabled },
        },
    } = store.getState();

    // if (e.type === "angularToReact" && e.detail && e.detail.action === "setDarkMode") {
    //     setInitialDarkMode(e.detail.value);
    // }

    if (e.type === "angularToReact" && e.detail && e.detail.action === "setCurrentRoute") {
        if (e.detail.value === "/") {
            setCurrentRoute({ route: "/" });
            if (currentTab === -1) {
                setCurrentTab(0);
            }
        }
    }

    if (e.type === "angularToReact" && e.detail && e.detail.action === "addTab") {
        if (e.detail.value) {
            addTab(e.detail.value);
        }
    }

    // if (e.type === "angularToReact" && e.detail && e.detail.action === "setAuthToken") {
    //     // setAuthToken(e.detail.value.authToken);
    //     // setBaseUrl(e.detail.value.baseUrl);
    // }

    // if (e.type === "angularToReact" && e.detail && e.detail.action === "setSidebar") {
    //     setSidebarEnabled(e.detail.side, e.detail.value);
    // }
};
// eslint-disable-next-line no-undef
if (!_isBrowser) {
    const { ipcRenderer } = window.require("electron");
    if (ipcRenderer) {
        const ipcListeners = [
            {
                channel: "electron.command",
                listener: (e, arg) => {
                    if (arg && arg.command) {
                        if (arg.command.type === "dialog") {
                            const { openDialog } = useStore.getState().dashboard;
                            openDialog({
                                icon: arg.command.icon,
                                title: arg.command.title,
                                plugin: arg.command.plugin,
                                component: arg.command.component,
                                data: arg.command.data,
                                firstInstance: arg.firstInstance,
                            });
                        } else {
                            const path = window.require("path");
                            const fs = window.require("fs-extra");
                            const { addTab } = useStore.getState().dashboard;
                            const { setIncEmail } = useStore.getState().dashboard;
                            const { closeEmailTabs } = useStore.getState().dashboard;
                            if (fs.pathExistsSync(arg.command.data.temp_path)) {
                                closeEmailTabs();
                                const email = fs.readJsonSync(path.join(arg.command.data.temp_path, "email.json"), { throws: false });
                                email.html_content = sanitizeHtml(email.html_content, {
                                    allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]),
                                    allowedSchemesByTag: {
                                        img: sanitizeHtml.defaults.allowedSchemes.concat(["data", "blob", "cid"]),
                                    },
                                    allowedAttributes: {
                                        "*": ["href", "align", "alt", "center", "bgcolor", "height", "width", "style", "color", "border", "checked",
                                            "cols", "colspan", "datetime", "hidden", "label", "max", "maxlength", "min", "rows", "rowspan", "selected",
                                            "shape", "size", "span", "start", "type", "disabled", "headers", "list", "cellspacing", "font-color",
                                            "background-color", "display", "src", "text-align", "font-family", "target"],
                                    },
                                });
                                email.attachments = email.attachments.map((attachment) => new File([new Blob([fs.readFileSync(path.normalize(path.join(arg.command.data.temp_path, attachment.filename)))])], attachment.filename));
                                if (email) {
                                    if (email.subject && email.subject.match(/#PT([0-9]{8})(,[0-9]{8})*#/g) && email.subject.match(/#PT([0-9]{8})(,[0-9]{8})*#/g)[0]) {
                                        email.taskIds = email.subject.match(/#PT([0-9]{8})(,[0-9]{8})*#/g)[0].replace("#PT", "")
                                            .replace("#", "")
                                            .split(",");
                                    }
                                    email.temp_path = arg.command.data.temp_path;
                                    setIncEmail(email);
                                    if (email.taskIds) {
                                        email.taskIds.forEach(async (id) => {
                                            const isClosed = await getTask(id);
                                            if (!isClosed) {
                                                addTab({
                                                    icon: "tasks",
                                                    title: id,
                                                    plugin: "tasks",
                                                    component: "Task",
                                                    data: {
                                                        id,
                                                        incEmail: email,
                                                    },
                                                });
                                            } else {
                                                addTab({
                                                    icon: "envelope",
                                                    title: "E-Mail",
                                                    plugin: "tasks",
                                                    component: "inc_mail",
                                                    data: {
                                                        email,
                                                    },
                                                });
                                            }
                                        });
                                    } else {
                                        addTab({
                                            icon: "envelope",
                                            title: "E-Mail",
                                            plugin: "tasks",
                                            component: "inc_mail",
                                            data: {
                                                email,
                                            },
                                        });
                                    }
                                }
                                // $scope.$on("$destroy", function() {
                                //     fs.removeSync($scope.temp_path)
                                // });
                            }
                        }
                    }
                },
            },
            {
                channel: "electron.isAnyMainReady",
                listener: () => {
                    ipcRenderer.send("main.isReady");
                },
            },
            {
                channel: "electron.isInactive",
                listener: (e, arg) => {
                    useStore.getState().app.sendToSleep(arg);
                },
            },
            {
                channel: "electron.setSystemIdleTime",
                listener: (e, arg) => {
                    useStore.getState().app.setSystemIdleTime(arg);
                },
            },
            {
                channel: "electron.updateElectronConfig",
                listener: (e, arg) => {
                    useStore.getState().app.updateElectronConfig(arg);
                },
            },
            {
                channel: "electron.close",
                listener: (e, arg) => {
                    if (!useStore.getState().dashboard.handleCloseAll()) {
                        e.sender.send("close", arg);
                    } else {
                        useStore.getState().dashboard.setSender({ sender: e.sender, arg });
                    }
                },
            },
            // {
            //     channel: "electron.stats",
            //     listener: (e, arg) => {
            //         console.log(arg);
            //     },
            // },
        ];

        ipcListeners.forEach((ipcListener) => {
            ipcRenderer.on(ipcListener.channel, ipcListener.listener);
        });

        // $scope.$on("$destroy", () => {
        //     ipcListeners.forEach(ipcListener => {
        //         ipcRenderer.removeListener(ipcListener.channel, ipcListener.listener);
        //     });
        // });
    }
}

store.subscribe((state) => state.app.isAuthenticated, (isAuthenticated) => {
    const {
        app: {
            baseUrl, authToken, refreshToken, setAuthToken, setRefreshToken, setUserInfo, setAppInfo, fetchRights, setSocketId, checkChangeLogs,
            fetchMasterData,
            fetchAddressConfig,
            fetchAddIns,
            fetchPluginsSettings,
            getElectronConfig,
            logout,
        },
        layouts: { fetch: fetchLayouts },
        dashboard: { fetch: fetchDashboard },
        menu: { fetch: fetchMenu },
        socket: {
            isConnected, setIsConnected, setUsers, updateUser, removeUser,
        },
        datasets: {
            setDataSets,
        },
    } = store.getState();

    if (isAuthenticated) {
        (async () => {
            try {
                const { data: appInfo } = await api.appInfo.get();

                // eslint-disable-next-line no-underscore-dangle
                if (appInfo.__custom_icon_exists && appInfo.custom_icon_enabled) {
                    const { data: appInfoCustomIcon } = api.appInfo.getCustomIcons();
                    appInfo.custom_icon = appInfoCustomIcon;
                }

                setAppInfo(appInfo);
                // eslint-disable-next-line no-undef
                if (!_isBrowser) {
                    getElectronConfig();
                }
            } catch (e) {
                console.error("appInfo", e);
            }
        })();

        if (!isConnected) {
            socket.connect(baseUrl, authToken, refreshToken, (newSocketId) => {
                setIsConnected(true);

                socket.on("unauthorized.forceLogout", () => {
                    logout();
                }, true);

                socket.on("notifications.notify", (data) => {
                    notify({
                        options: {
                            ...data.options,
                            type: data.options?.type || "success",
                        },
                        data: data.data,
                    }, data.action);
                }, true);

                socket.on("notifications.reload", (data) => {
                    notify({
                        options: {
                            type: "warning",
                        },
                        data,
                    });
                }, true);

                socket.on("react.build.start", (data) => {
                    const {
                        app: {
                            rights,
                        },
                    } = store.getState();

                    if (rights?.plugins?.rights?.read) {
                        notify({
                            options: {
                                toastId: `react.build-${data.id}`,
                            },
                            data: {
                                title: "Client Update: wird installiert",
                            },
                        }, "loading");
                    }
                }, true);

                socket.on("react.build.done", (data) => {
                    const {
                        app: {
                            rights,
                        },
                    } = store.getState();

                    if (rights?.plugins?.rights?.read) {
                        notify({
                            options: {
                                toastId: `react.build-${data.id}`,
                                type: "success",
                                isLoading: false,
                                autoClose: false,
                                closeOnClick: false,
                                closeButton: false,
                            },
                            data: {
                                title: "Client Update: erfolgreich installiert",
                                message: "Anwendung bitte neu laden",
                                reload: true,
                            },
                        }, "update");
                    } else {
                        notify({
                            options: {
                                type: "success",
                                isLoading: false,
                                autoClose: false,
                                closeOnClick: false,
                                closeButton: false,
                            },
                            data: {
                                title: "Client Update: erfolgreich installiert",
                                message: "Anwendung bitte neu laden",
                                reload: true,
                            },
                        });
                    }
                }, true);

                socket.on("react.build.error", (data) => {
                    const {
                        app: {
                            rights,
                        },
                    } = store.getState();

                    if (rights?.plugins?.rights?.read) {
                        notify({
                            toastId: `react.build-${data.id}`,
                            type: "error",
                            isLoading: false,
                            autoClose: false,
                            data: {
                                title: "Client Update: fehlgeschlagen",
                                message: data.error,
                            },
                        }, "update");
                    }
                }, true);

                socket.on("userInfo", (data) => {
                    const {
                        datasets: {
                            datasets,
                        },
                        app: {
                            socketId,
                        },
                        // dashboard: {
                        //     tabs,
                        // },
                    } = store.getState();

                    if (data.newToken) {
                        setAuthToken(data.newToken.token, true);
                        setRefreshToken(data.newToken.refreshToken, true);
                        socket.updateTokens(data.newToken.token, data.newToken.refreshToken);
                    }

                    setUserInfo(data);
                    checkChangeLogs(data.user_id);
                    if (socketId !== newSocketId) {
                        const myDatasets = datasets
                            .filter((dS) => dS.socket_id === socketId)
                            // remove closed tabs
                            // .filter((dS) => tabs.find((tab) => dS.tab_id === tab.id))
                            .map((dS) => ({ ...dS }));

                        // console.log(myDatasets);
                        // console.log(tabs);
                        //
                        // console.log(tabs.filter((tab)=>!myDatasets.find((dS)=>ds.tab_id === tab.id)).map((tab)=>({
                        //     id: tab.id,
                        //     socket_id
                        // })))

                        myDatasets.forEach((item) => {
                            item.socket_id = newSocketId;
                        });
                        if (myDatasets.length > 0) {
                            socket.emit("dataset.syncBack", myDatasets);
                        } else {
                            socket.emit("dataset.fetch");
                        }
                    } else {
                        socket.emit("dataset.fetch");
                    }

                    setSocketId(newSocketId);

                    fetchDashboard();
                    fetchMenu();
                    fetchRights();
                    fetchLayouts();
                    fetchAddressConfig();
                    fetchAddIns();
                    fetchPluginsSettings();
                    fetchMasterData();
                }, true);

                socket.emit("users.getList");

                socket.on("users.list", (data) => {
                    setUsers(data);
                }, true);

                socket.on("user.update", (data) => {
                    updateUser(data);
                }, true);

                socket.on("user.remove", (id) => {
                    removeUser(id);
                }, true);

                socket.on("reloadConfig", async () => {
                    await fetchRights();
                }, true);

                socket.on("dataset.sendToAll", (data, cb) => {
                    const {
                        app: {
                            socketId,
                        },
                    } = store.getState();

                    if (cb) cb(socketId);

                    if (socketInitTimeStamp !== data.socketInitTimeStamp) {
                        socketInitTimeStamp = data.socketInitTimeStamp;
                        datasetsSendToAllCount = 0;
                    }

                    if (data.datasetsSendToAllCount > datasetsSendToAllCount) {
                        datasetsSendToAllCount = data.datasetsSendToAllCount;
                        setDataSets(data.datasets);
                    }
                }, true);
                socket.on("boilerplates.update", async () => {
                    await store.getState().app.fetchBoilerplates();
                });
            });
        }
    } else if (isConnected) {
        socket.disconnect(() => {
            setIsConnected(false);
        });
    }
});

// store.subscribe((users) => {
//     // eslint-disable-next-line no-console
//     console.log(users);
// }, (state) => state.socket.users);
//
// store.subscribe((userInfo) => {
//     // eslint-disable-next-line no-console
//     console.log(userInfo);
// }, (state) => state.app.userInfo);

// store.subscribe((dashboard) => {
//     console.log(dashboard);
// }, (state) => state.dashboard);
//
// store.subscribe((customValues) => {
//     console.log("customValues", customValues);
// }, (state) => state.custom.values);

// store.subscribe((zoom) => {
//     // eslint-disable-next-line no-undef
//     if (!_isBrowser) {
//         const { webFrame } = window.require("electron");
//         webFrame.setZoomFactor(zoom);
//     }
// }, (state) => state.app.zoom);

// // eslint-disable-next-line no-undef
// if (!_isBrowser) {
//     const { webFrame } = window.require("electron");
//     webFrame.setZoomFactor(1);
// }

store.subscribe((state) => state.errors.errors, (errors) => {
    console.error("Store: state.errors.errors", errors);
});

// // TODO: debug sychronisation with different cases: users, tabs, browser instances
// store.subscribe((state) => state.datasets, (datasets) => {
//     if (true) console.log(datasets.datasets);
// });

// store.subscribe((layout) => {
//     console.log(layout);
// }, state => state.layout);

window.addEventListener("angularToReact", handleAngularEvent);

// for testing without angular
// const {
//     app: {
//         setAuthToken, setBaseUrl,
//     },
// dashboard: {
//     addTab,
//     // },
// } = store.getState();

// setBaseUrl("http://localhost:3020");
// setBaseUrl("http://localhost:3333");
// setAuthToken("JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywibG9naW4iOiJnZ2VocmtlIiwiaWF0IjoxNjk1ODA2ODk4fQ.I4pAcytVIBWqxQlseynDFxb5Q9-oLLq6htVS4iEuET8");
// addTab({
//     icon: "tasks",
//     title: 22000773,
//     plugin: "tasks",
//     component: "Task",
//     data: {
//         id: 22000773,
//     },
// });

(async () => {
    try {
        // TODO: test with electron!!!
        const {
            app: {
                setAuthToken,
                setRefreshToken,
                setBaseUrl,
                setAppInfo,
                logout,
            },
        } = store.getState();

        let configStore;

        // eslint-disable-next-line no-undef
        if (!_isBrowser) {
            const Store = window.require("electron-store");
            configStore = new Store();
        }

        // eslint-disable-next-line no-undef,no-restricted-globals
        setBaseUrl(_isBrowser ? (`${location.protocol}//${location.host}`) : configStore.get("baseUrl"));
        const { data: appInfo } = await api.appInfo.get();
        setAppInfo(appInfo);

        let token;
        let refreshToken;

        if (appInfo.is_helpdesk) {
            token = window.localStorage.getItem("ptmToken");
            refreshToken = window.localStorage.getItem("ptmRefreshToken");
            // eslint-disable-next-line no-undef
        } else if (_isBrowser) {
            token = window.localStorage.getItem("ptmToken");
            refreshToken = window.localStorage.getItem("ptmRefreshToken");
        } else if (configStore.has("ptmToken")) {
            token = configStore.get("ptmToken");
            refreshToken = configStore.get("ptmRefreshToken");
        } else if (window.localStorage.getItem("ptmToken")) {
            token = window.localStorage.getItem("ptmToken");
            configStore.set("ptmToken", token);
            window.localStorage.removeItem("ptmToken");

            token = window.localStorage.getItem("ptmRefreshToken");
            configStore.set("ptmRefreshToken", token);
            window.localStorage.removeItem("ptmRefreshToken");
        }

        if (token) {
            setAuthToken(token);
            setRefreshToken(refreshToken);

            window.dispatchEvent(new CustomEvent("reactToAngular", {
                detail: {
                    action: "setAuthToken",
                    value: {
                        authToken: token,
                        refreshToken,
                    },
                },
            }));
        } else {
            logout();
        }
    } catch (e) {
        console.error("appInfo", e);
    }
})();

export default useStore;

axios.interceptors.response.use((response) => response, async (error) => {
    const {
        app: {
            refreshToken,
            setRefreshToken,
            setAuthToken,
            userInfo: {
                user_id: userId,
                contact_id: contactId,
            },
            appInfo: {
                is_helpdesk: isHelpDesk,
            },
            logout,
        },
    } = store.getState();

    const originalRequest = error.config;

    // eslint-disable-next-line no-underscore-dangle
    if (error.response?.status === 401 && !originalRequest?._retry) {
        // if (originalRequest.method === "post") {
        //     originalRequest.data = JSON.parse(originalRequest.data);
        // }
        // eslint-disable-next-line no-underscore-dangle
        originalRequest._retry = true;
        const instance = axios.create();
        return await instance.post("/api/auth/refresh", {
            userId,
            contactId,
            refreshToken,
        }).then(async ({ data }) => {
            if (!data.dontUpdate) {
                setRefreshToken(data.refreshToken, true);
                setAuthToken(data.token, true);

                socket.updateTokens(data.token, data.refreshToken);
            }

            originalRequest.headers.Authorization = data.token;
            axios.defaults.headers.common.Authorization = data.token;

            return axios(originalRequest);
        }).catch((err) => {
            if (isHelpDesk) {
                logout();
            } else if (err.message?.includes("404")) {
                return Promise.reject(error);
            }
        });
    }

    return Promise.reject(error);
});
